var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Manual component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconManual extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0237 1.10498H5.75744C4.95176 1.10474 4.17764 1.41907 3.6003 1.98102C3.0229 2.54302 2.68777 3.30825 2.66628 4.1137L2.66602 4.1337V19.7414L2.6663 19.7621L2.66602 19.8038C2.66602 20.6237 2.99169 21.4099 3.57139 21.9896C4.1511 22.5693 4.93734 22.895 5.75717 22.895H20.5845C20.9987 22.895 21.3345 22.5592 21.3345 22.145C21.3345 21.7308 20.9987 21.395 20.5845 21.395H19.7737V18.0876C20.1034 17.9744 20.4065 17.787 20.6577 17.5359C21.091 17.1025 21.3345 16.5148 21.3345 15.9019V3.41575C21.3345 2.8029 21.091 2.21514 20.6577 1.78179C20.2243 1.34844 19.6366 1.10498 19.0237 1.10498ZM19.0283 16.7127C19.0268 16.7127 19.0252 16.7126 19.0237 16.7126C19.0215 16.7126 19.0194 16.7127 19.0173 16.7127H5.75717C5.19193 16.7127 4.64265 16.8675 4.16602 17.1536V4.14467C4.17932 3.73338 4.35148 3.3431 4.64653 3.05592C4.94374 2.76664 5.34242 2.60483 5.75717 2.60498H19.0237C19.2387 2.60498 19.445 2.6904 19.597 2.84245C19.7491 2.9945 19.8345 3.20072 19.8345 3.41575V15.9019C19.8345 16.1169 19.7491 16.3232 19.597 16.4752C19.446 16.6262 19.2417 16.7115 19.0283 16.7127ZM18.2737 18.2127V21.395H5.75717C5.33517 21.395 4.93045 21.2273 4.63205 20.9289C4.33365 20.6305 4.16602 20.2258 4.16602 19.8038C4.16602 19.3818 4.33365 18.9771 4.63205 18.6787C4.93045 18.3803 5.33517 18.2127 5.75717 18.2127H18.2737Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconManual.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconManual.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconManual.prototype, "size", void 0);
if (customElements.get('cat-icon-manual') === undefined) {
    customElements.define('cat-icon-manual', BlocksIconManual);
}
